// extracted by mini-css-extract-plugin
module.exports = {"link":"_2k7xj","root":"_2btH0","label":"nr31w"};